import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UiBlockService {
  private readonly _block$ = new BehaviorSubject<boolean>(false);
  public block$ = this._block$.asObservable();

  setBlocked(blocked: boolean) {
    this._block$.next(blocked);
  }
}
